import React from 'react';
import { Container } from '@components/Container';
import { Section } from '@components/Section';
import { EditTrialForm } from '@pages/Trial/pages/EditTrial/EditTrialForm';

export const EditTrial = () => (
  <div className="main-content">
    <Container size="lg">
      <div className="panel">
        <Section containerSize="md">
          <EditTrialForm />
        </Section>
      </div>
    </Container>
  </div>
);
